import script from "./course.vue?vue&type=script&setup=true&name=Course&lang=js"
export * from "./course.vue?vue&type=script&setup=true&name=Course&lang=js"

import "./course.vue?vue&type=style&index=0&id=20fa3d33&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20fa3d33"]])

export default __exports__